module.exports = __webpack_public_path__ + "img/logosvg.b253f95d.svg";